/**
 * Card colour swatches -> product-card image swap (Impact theme)
 * ---------------------------------------------------------------------------
 * Powers the metafield-driven colour dots on collection/product cards
 * (snippets/card-color-swatches.liquid). Clicking a dot swaps THAT card's
 * primary image to the colour's representative photo, whose URL/srcset are
 * inlined on the dot as data attributes -- so there is no network fetch and it
 * never touches variants, price or inventory.
 *
 * One delegated listener on the document (initialised once), so it works for
 * every card on the page and survives section re-renders / infinite scroll.
 */
(function () {
  if (window.__cardColorSwatchInit) return;
  window.__cardColorSwatchInit = true;

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('.card-color-swatch');
    if (!swatch) return;

    var card = swatch.closest('product-card');
    if (!card) return;

    var img = card.querySelector('.product-card__image--primary');
    if (!img) return;

    var src = swatch.getAttribute('data-card-image-src');
    var srcset = swatch.getAttribute('data-card-image-srcset');
    if (!src) return;

    // Swap the card's primary image (plain <img>, so a direct src/srcset swap).
    if (srcset) {
      img.srcset = srcset;
    } else {
      img.removeAttribute('srcset');
    }
    img.src = src;

    // Move the selected state within this card's swatch group only.
    var group = swatch.closest('.product-card__swatch-list') || card;
    group.querySelectorAll('.card-color-swatch.is-selected').forEach(function (el) {
      el.classList.remove('is-selected');
    });
    swatch.classList.add('is-selected');
  });
})();
